import { connect } from 'react-redux';
import App from '../components/App';
import { fetchInitialData } from 'data/app/App.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    initialLoadingComplete: state.app.initialLoadingComplete,
    lang: state.i18n.locale,
    loading: state.app.loading,
    location: state.routing.locationBeforeTransitions || {},
    user: state.app.user,
    userParty: state.app.userParty,
    merchantFees: state.app.merchantFees,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onAppInit: () => dispatch(fetchInitialData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
